import { useEffect } from "react";
import { appInsights } from "../../config/appInsights";
import OnboardingRequests from "../Requests/Tabs/OnboardingRequests";

export default function InvestorCreationApproval() {
  useEffect(() => {
    appInsights.trackPageView({
      name: "Investor Creation Approval - (InvestorCreationApproval.tsx)",
      isLoggedIn: true,
    });
  }, []);

  return (
    <div className="datatable-wrapper">
      <div className="table-view speed-1x animated fadeInRight">
        <h3 className="page-title mb-4">Investor Creation Approval</h3>
        <OnboardingRequests />
      </div>
    </div>
  );
}
